import classnames from "classnames";
import React from "react";
import ResetState from "./resetstate";
import { INPUT_LIMITS } from "../input-limits";

function TextInput({
  label,
  value,
  onChange,
  className,
  placeholder = "",
  resetValue,
  isResetVisible = true,
  minLength,
  maxLength,
  onBlur,
}) {
  const handleTextChange = (e) => {
    onChange(e.target.value);
  };

  if (value === undefined || value === null) {
    value = "";
  }

  const classes = classnames(
    "grigora-text-input text-grigora-base  mb-2 flex flex-col justify-between gap-[4px] select-none",
    className,
  );

  return (
    <div className={classes}>
      <div className="grigora-text-input__label flex justify-between">
        {label && label}
        {isResetVisible && (
          <ResetState
            active={resetValue !== undefined && value !== resetValue}
            onClick={() => {
              onChange(resetValue);
            }}
          />
        )}
      </div>
      <div className="w-full flex items-center ">
        <input
          type="text"
          value={value}
          onChange={handleTextChange}
          placeholder={placeholder}
          minLength={
            minLength ? minLength : INPUT_LIMITS["default-text-input"].minlength
          }
          maxLength={
            maxLength ? maxLength : INPUT_LIMITS["default-text-input"].maxlength
          }
          onBlur={onBlur}
          className="grigora-text-input__field h-6 border-[1px] border-gray-300 px-2 py-3 w-full bg-editor-input-selected rounded-[6px] focus-visible:outline-none"
        />
      </div>
    </div>
  );
}

export default TextInput;
